import { Configure, Hits, useConnector } from 'react-instantsearch-hooks-web';
import connectStats from 'instantsearch.js/es/connectors/stats/connectStats';
import { useSitecoreContext } from '@sitecore-jss/sitecore-jss-nextjs';

import type {
  StatsConnectorParams,
  StatsWidgetDescription,
} from 'instantsearch.js/es/connectors/stats/connectStats';
import { CustomPagination } from '../../CustomPagination';
import classNames from 'classnames';
import { HitProps } from '../../Hits/_types';
import NrcSearchHit from 'components/helpers/AlgoliaSearch/NetworkResourceCenter/NRCSearchHit';

export type UseStatsProps = StatsConnectorParams;

function useStats(props?: UseStatsProps) {
  // eslint-disable-next-line @typescript-eslint/no-explicit-any
  return useConnector<StatsConnectorParams, StatsWidgetDescription>(connectStats as any, props);
}

interface IMyProps {
  searchCategory: string;
}

const SearchListingHit = ({ hit }: HitProps) => {
  return <NrcSearchHit hit={hit} component="searchListing" />;
};

const SearchResultsWithSearch = ({ searchCategory }: IMyProps, props: UseStatsProps) => {
  const { nbHits } = useStats(props);
  const configureFilters = `searchableCategory:"${searchCategory}"`;
  const showPagination = nbHits > 10;
  return (
    <div>
      <Configure analytics={false} filters={configureFilters} hitsPerPage={10} />
      <div>
        <Hits hitComponent={SearchListingHit} />
      </div>
      <div className={classNames({ hidden: !showPagination })}>
        <CustomPagination padding={1} />
      </div>
    </div>
  );
};

const SearchListingResults = ({ searchCategory }: IMyProps, props: UseStatsProps) => {
  const { sitecoreContext } = useSitecoreContext();
  const pageEditing = sitecoreContext.pageEditing === true;
  if (pageEditing) {
    return <div>Search Results will be shown here</div>;
  }
  return <SearchResultsWithSearch searchCategory={searchCategory} {...props} />;
};

export default SearchListingResults;
